import React, { useEffect, useState } from "react";
import { Box } from "@rebass/grid";
import { Container } from "../";
import { categoryGenerator, deliveryGenerator } from "./buttonGenerator";
import "./extra-styles.scss";

const DataFetching = ({ bizData, isFetching, location, children }) => {
  const [filters, setFilters] = useState({});
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    let filteredData = bizData;

    if (location) {
      filteredData = filteredData.filter((biz) => biz.group === location);
    }

    if (filters.category && filters.category !== "") {
      filteredData = filteredData.filter(
        (biz) => biz.category === filters.category
      );
    }

    if (filters.group && filters.group !== "") {
      filteredData = filteredData.filter((biz) => biz.group === filters.group);
    }

    if (filters.delivery && filters.delivery !== "") {
      filteredData = filteredData.filter((biz) => {
        return biz[filters.delivery] === true;
      });
    }

    setFilteredData(filteredData);
  }, [bizData, filters]);

  const updateFilters = ({ id, value }) => {
    setFilters({
      ...filters,
      [id]: value,
    });
  };

  return (
    <>
      <Container>
        <Box px={3} py={3} width={1}>
          {categoryGenerator(bizData, updateFilters, filters)}
          {deliveryGenerator(updateFilters, filters)}
          <div
            className="button-filter transparent"
            onClick={() => setFilters({})}
          >
            clear filters
          </div>
        </Box>
      </Container>

      <>{children(filteredData)}</>
    </>
  );
};

export default DataFetching;
